import * as React from 'react'

import * as styles from './pageTextHeading.module.css'

interface IProps {
  title: string
  subtitle?: string
}

const PageTextHeading = ({ title, subtitle }: IProps) => {
  return (
    <div className={styles.root}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <h2 className={styles.subtitle}>{subtitle}</h2>}
    </div>
  )
}

export default PageTextHeading
